import { render, staticRenderFns } from "./CodePage.vue?vue&type=template&id=61bb4fda&scoped=true&"
import script from "./CodePage.vue?vue&type=script&lang=js&"
export * from "./CodePage.vue?vue&type=script&lang=js&"
import style0 from "./CodePage.vue?vue&type=style&index=0&id=61bb4fda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bb4fda",
  null
  
)

export default component.exports